import { render, staticRenderFns } from "./merchantTranslateDetails.vue?vue&type=template&id=6aaa6a1e"
import script from "./merchantTranslateDetails.vue?vue&type=script&lang=js"
export * from "./merchantTranslateDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports